import { NgClass, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IStepItem } from '@shared/core';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'ui-stepper-horizontal',
  templateUrl: './stepper-horizontal.component.html',
  styleUrls: ['./stepper-horizontal.component.scss'],
  standalone: true,
  imports: [NgStyle, NgClass, NzIconModule],
})
export class UIStepperHorizontal {
  @Input() items: IStepItem[] = [];

  // Dynamically calculate the number of dashes
  get dashes(): number[] {
    const containerWidth = 120; // Assume the card container width
    const dashWidth = 16; // Dash width
    const gapWidth = 4; // Space between dashes
    const totalDashSpace = containerWidth / (dashWidth + gapWidth);
    return Array(Math.floor(totalDashSpace)).fill(0);
  }
}
